
export interface MapModel {
    address: string,
    street: string,
    state: string,
    postCode: string,
    city: string,
    entreCalles?: string,
    depto: string,
    coordinates: {
        lon: number,
        lat: number
    }
    //accessLocation: boolean,
}

export interface DirecGoogle {
    types: string [],
    formatted_address: string,
    address_components: AdressComponentGoogle[],
    partial_match: boolean,
    place_id: string,
    postcode_localities: string[],
    geometry: {
      location: {
        lat:number,
        lng:number,
      },
      location_type: string,
    }
}
export interface AdressComponentGoogle {
    short_name: string,
    long_name: string,
    postcode_localities: string[],
    types: string[],
}

export interface ResultGoogle {
    results: DirecGoogle[],
    status: string,
}

export const regionMapPY: { aliases: string[]; name: string }[] = [
  { aliases: ['ALTO PARAGUAY, PARAGUAY'], name: 'ALTO PARAGUAY' },
  { aliases: ['ALTO PARANA', 'PARANA', 'ALTO PARANÁ'], name: 'ALTO PARANA' },
  { aliases: ['AMAMBAY'], name: 'AMAMBAY' },
  { aliases: ['ASUNCION', 'ASUNCIÓN', 'CAPITAL'], name: 'ASUNCION' },
  { aliases: ['BOQUERON', 'BOQUERÓN'], name: 'BOQUERON' },
  { aliases: ['CAAGUAZU', 'CAAGUAZÚ'], name: 'CAAGUAZU' },
  { aliases: ['CAAZAPA', 'CAAZAPÁ'], name: 'CAAZAPA' },
  { aliases: ['CANINDEYU', 'CANINDEYÚ'], name: 'CANINDEYU' },
  { aliases: ['CENTRAL'], name: 'CENTRAL' },
  { aliases: ['CONCEPCION', 'CONCEPCIÓN'], name: 'CONCEPCION' },
  { aliases: ['CORDILLERA'], name: 'CORDILLERA' },
  { aliases: ['GUAIRA', 'GUAIRÁ'], name: 'GUAIRA' },
  { aliases: ['ITAPUA', 'ITAPÚA'], name: 'ITAPUA' },
  { aliases: ['MISIONES'], name: 'MISIONES' },
  { aliases: ['ÑEEMBUCU', 'NEEMBUCU', 'ÑEEMBUCÚ'], name: 'ÑEEMBUCU' },
  { aliases: ['PARAGUARI', 'PARAGUARÍ'], name: 'PARAGUARI' },
  { aliases: ['PRESIDENTE HAYES', 'HAYES'], name: 'PRESIDENTE HAYES' },
  { aliases: ['SAN PEDRO'], name: 'SAN PEDRO' }
];


